import React from 'react';
import styled from 'styled-components';
import { css } from '../styled-components';
import Container from './Container';
import Section from './Section';

export const NavigationLinks = css`
    ul {
        font-size: 1.1em;
        font-weight: 700;
        list-style: none;
        padding: 0;

        li {
            margin: 1em 0;
        }
    }

    a {
        text-decoration: none;
        color: ${props => props.theme.primary};
    }
`;

const FooterStyle = styled.footer`
    grid-area: Footer;
    font-weight: 400;
    color: ${props => props.theme.textInverted};
    ${NavigationLinks};
`;

const Columns = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const Column = styled.div`
    flex: 1 0 auto;
    min-width: 18rem;
`;
const Small = styled.p`
    font-size: 0.7em;
    margin: 0.6em 0;
    color: #fff9;
`;

const year = new Date().getFullYear();

const Footer = () => (
    <FooterStyle>
        <Section dark>
            <Container>
                <Columns>
                    <Column>
                        <h2>R-Squared Global</h2>
                        <p>
                            Loerracherstrasse 50 <br />
                            4125 Riehen <br />
                            Switzerland
                        </p>
                        <p>Email contact@r-squared.ch</p>
                    </Column>
                    <Column />
                </Columns>
                <div>
                    <p style={{ marginTop: 60 }}>
                        © {year} R-Squared -{' '}
                        <a href="/fair-processing-notice">Fair Processing Notice / Privacy Policy</a>
                    </p>
                    <Small style={{ marginTop: 30 }}>
                        Webpage made by{' '}
                        <a href="https://apptiva.ch/" title="Apptiva AG" target="_blank" rel="noopener noreferrer">
                            Apptiva
                        </a>
                        .
                    </Small>
                    <Small>
                        Icons made by{' '}
                        <a
                            href="https://www.flaticon.com/authors/good-ware"
                            title="Good Ware"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Good Ware
                        </a>
                        ,{' '}
                        <a
                            href="https://www.flaticon.com/authors/iconnice"
                            title="Iconnice"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Iconnice
                        </a>
                        ,{' '}
                        <a
                            href="https://www.flaticon.com/authors/smashicons"
                            title="Smashicons"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Smashicons
                        </a>
                        ,{' '}
                        <a
                            href="https://www.flaticon.com/authors/vectors-market"
                            title="Vectors Market"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Vectors Market
                        </a>{' '}
                        from{' '}
                        <a href="https://www.flaticon.com/" title="Flaticon" target="_blank" rel="noopener noreferrer">
                            www.flaticon.com
                        </a>{' '}
                        is licensed by{' '}
                        <a
                            href="http://creativecommons.org/licenses/by/3.0/"
                            title="Creative Commons BY 3.0"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            CC 3.0 BY
                        </a>
                    </Small>
                </div>
            </Container>
        </Section>
    </FooterStyle>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.tsx